// extracted by mini-css-extract-plugin
module.exports = {"container":"AutoReview_container__3eJ8B","headerBar":"AutoReview_headerBar__3SNN_","addButton":"AutoReview_addButton__3IFjH"};